import React, { Component } from 'react';
import { debounce } from 'lodash';
import './AddFriendForm.css';

import isValidEmail from '../utils/is-valid-email.js';
import AddFriendCell from './AddFriendCell.js';

class AddFriendForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      searching: false,
      searched: false,
      searchingError: null,
      invitedUser: false
    };
  }

  componentDidMount() {
    // Autofocus the search field.
    this.searchInput.focus();
  }

  handleInputChange = (ev) => {
    const { target } = ev;
    const { value: query } = target;
    this.setState({ query });

    if (query && query.length > 0) {
      this.search();
    }
  }

  search = debounce(() => {
    const { query } = this.state;
    console.log('Searching for user:', query);

    this.props.searchFriends({ email: query });
  }, 1000)

  inviteUser = () => {
    const { inviteUser } = this.props;
    const { query } = this.state;
    console.log('Inviting user:', query);
    inviteUser({ email: query.trim() });
    this.setState({ invitedUser: true });
  }

  render() {
    const {
      className,
      searchResults,
      isSearching,
      hasSearched,
      errorSearching,
      addFriend
    } = this.props;

    const { invitedUser, query } = this.state;

    let results = <section className="AddFriendForm__empty">
        <svg className="AddFriendForm__empty-image" width="74" height="74" viewBox="0 0 74 74" xmlns="http://www.w3.org/2000/svg"><path d="M52.294 48.227l20.64 20.64a2.876 2.876 0 1 1-4.067 4.067l-20.64-20.64A29.379 29.379 0 0 1 29.5 59C13.208 59 0 45.792 0 29.5S13.208 0 29.5 0 59 13.208 59 29.5c0 7.11-2.516 13.634-6.706 18.727zM29.5 54C43.031 54 54 43.031 54 29.5S43.031 5 29.5 5 5 15.969 5 29.5 15.969 54 29.5 54z" fill="#D8D8D8" fillRule="evenodd"/></svg>
        <p className="AddFriendForm__empty-text">Search for friends on Normal Chat with either their Normal ID or email.</p>
      </section>;

    // If the user has searched for something and it's resolved
    // with no results, tell the user their search has come up with nothing.
    if (query && !searchResults.length && hasSearched) {
      let inviteButton = null;

      if (isValidEmail(query)) {
        inviteButton = <button className="Button--outline" onClick={this.inviteUser}>Invite {query.trim()} to Normal Chat</button>;
      }

      if (invitedUser) {
        inviteButton = <button className="Button--outline" disabled={true}>Invited!</button>;
      }

      results = <section className="AddFriendForm__empty">
        <p className="AddFriendForm__empty-text">Sorry, we can't find anyone with that email or ID on Normal Chat.</p>
        {inviteButton}
      </section>;
    }

    // Otherwise, if there is a result from the service, show the resulting user.
    if (searchResults.length) {
      let resultCells = searchResults.map((user) => <AddFriendCell user={user} addFriend={() => {addFriend(user.email)}} />);
      results = <section className="AddFriendForm__results">
        {resultCells}
      </section>;
    }

    let formClassNames = ['AddFriendForm'];
    if (className) {
      formClassNames.push(className);
    }

    return (
      <section className={formClassNames.join(' ')}>
        <input type="text"
          className="AddFriendForm__input"
          placeholder="Search with email or friend code..."
          ref={(input) => { this.searchInput = input; }}
          value={query}
          onChange={this.handleInputChange} />

        {results}
      </section>
    );
  }
}

export default AddFriendForm;



// WEBPACK FOOTER //
// ./src/components/AddFriendForm.js